const SORT_FNS = {
    price: (a, b) => parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')),
    'price-desc': (a, b) => parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')),
    title: (a, b) => (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || ''),
    'title-desc': (a, b) => (b.getAttribute('data-name') || '').localeCompare(a.getAttribute('data-name') || ''),
};

function normalize(str) {
    return str.toLowerCase()
        .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u')
        .replace(/ß/g, 'ss');
}

export default function initProductsPage() {
    const grid = document.querySelector('.products-page-grid');
    if (!grid) return;

    const cards = [...grid.querySelectorAll('.product-card')];
    const searchInput = document.getElementById('products-page-search-input');
    const searchWrapper = searchInput ? searchInput.closest('.products-page-search') : null;
    const sortSelect = document.querySelector('.products-page-ordering-select');

    if (!cards.length) return;

    let currentSearch = '';
    let currentSort = getParam('orderby');
    let searchTimer = null;

    if (sortSelect && currentSort) sortSelect.value = currentSort;
    applyAll();

    if (searchInput) {
        const clearBtn = searchWrapper ? searchWrapper.querySelector('.products-page-search-clear') : null;

        const toggleIcon = () => {
            if (searchWrapper) {
                searchWrapper.classList.toggle('has-value', searchInput.value.length > 0);
            }
        };

        searchInput.addEventListener('input', function () {
            toggleIcon();
            const val = this.value.trim();
            clearTimeout(searchTimer);
            if (val.length >= 3) {
                searchTimer = setTimeout(() => {
                    currentSearch = normalize(val);
                    applyAll();
                }, 300);
            } else if (val.length === 0) {
                currentSearch = '';
                applyAll();
            }
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                searchInput.value = '';
                toggleIcon();
                currentSearch = '';
                applyAll();
                searchInput.focus();
            });
        }

        toggleIcon();
    }

    if (sortSelect) {
        if (currentSort) sortSelect.value = currentSort;
        document.fonts.ready.then(() => updateSelectWidth(sortSelect));

        sortSelect.addEventListener('change', function () {
            currentSort = this.value === 'menu_order' ? '' : this.value;
            setParam('orderby', currentSort);
            updateSelectWidth(this);
            applyAll();
        });
    }

    window.addEventListener('popstate', () => {
        currentSort = getParam('orderby');
        if (sortSelect) {
            sortSelect.value = currentSort || 'menu_order';
            updateSelectWidth(sortSelect);
        }
        applyAll();
    });

    function applyAll() {
        const visibleCards = [];

        cards.forEach(card => {
            const name = card.getAttribute('data-name') || '';
            const matchSearch = !currentSearch || normalize(name).includes(currentSearch);

            if (matchSearch) {
                card.style.display = '';
                visibleCards.push(card);
            } else {
                card.style.display = 'none';
            }
        });

        if (currentSort && currentSort !== 'menu_order') {
            visibleCards.sort(SORT_FNS[currentSort] || (() => 0));
            visibleCards.forEach(card => grid.appendChild(card));
        }
    }

    function setParam(key, val) {
        const url = new URL(window.location);
        val ? url.searchParams.set(key, val) : url.searchParams.delete(key);
        history.pushState({}, '', url);
    }

    function getParam(key) {
        return new URLSearchParams(window.location.search).get(key) || '';
    }

    function updateSelectWidth(select) {
        const text = select.options[select.selectedIndex].text;
        let sizer = document.getElementById('products-page-ordering-sizer');
        if (!sizer) {
            sizer = document.createElement('span');
            sizer.id = 'products-page-ordering-sizer';
            sizer.style.position = 'absolute';
            sizer.style.left = '-9999px';
            sizer.style.top = '-9999px';
            sizer.style.visibility = 'hidden';
            sizer.style.whiteSpace = 'nowrap';
            document.body.appendChild(sizer);
        }
        const cs = getComputedStyle(select);
        sizer.style.fontFamily = cs.fontFamily;
        sizer.style.fontSize = cs.fontSize;
        sizer.style.fontWeight = cs.fontWeight;
        sizer.style.letterSpacing = cs.letterSpacing;
        sizer.textContent = text;
        select.style.width = sizer.offsetWidth + 'px';
    }
}
